module.exports = __webpack_public_path__ + "static/autobiography-of-a-spiritually-incorrect-mystic-7b643aec6197d5cb78babf57f0d6d05c.jpg";